<template>
  <div class="step-main">
    <Operation @add="addHandler" @mutiEdit="mutiEditHandler" @search="getSearchData"/>
    <AddCard :isShow="show_add_card" @addCancel="show_add_card = false"/>
    <!-- <div class="item-content">
      <div class="content-title">
          <div>
            上海市房地产估价师协会
          </div>
      </div>
    </div> -->
    <UseCardItem
      v-for="(item, idx) in using_association"
      :item="item"
      @on-click="setCurrentChannel"
      :key="'use' + idx" />
    <div class="stop-content">
      <div class="stop-left">
        <div style="display: flex;align-items:center;">
          <img class="stop-img" style="margin-right:8px;" src="../../assets/stoped.png">
        </div>
        <span class="stop-title">已停用组织</span>
      </div>
    </div>
    <StopCardItem
      v-for="(item, idx) in stoped_association"
      :item="item"
      :key="'stop' + idx" />
    <el-dialog title="批量设置有效期" center :visible.sync="showMutiEditDialog">
      <div class="flex-center">
        <div>
          将所有启用机构有效期设为
          <el-date-picker type="date" v-model="allValidityPeriod" value-format="yyyy-MM-dd" format="yyyy-MM-dd"/>
        </div>
      </div>
      <div slot="footer" class="flex-center">
        <el-button type="primary" size="medium" @click="saveMutiEdit">确定</el-button>
        <el-button size="medium" @click="hideMutiEditDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Operation from './Operation'
import AddCard from './AddCard'
import UseCardItem from './UseCardItem'
import StopCardItem from './StopCardItem'
import { allOnAssociation, allOffAssociation, mutiEdit } from '../../api/'
import { mapState } from 'vuex'
import Store from '@/store'
export default {
  components: {
    UseCardItem,
    StopCardItem,
    Operation,
    AddCard
  },
  computed: {
    ...mapState({
      search: 'search',
      using_association: 'using_association',
      stoped_association: 'stoped_association'
    })
  },
  data () {
    return {
      show_add_card: false,
      show_enable_card: false,
      allValidityPeriod: '',
      showMutiEditDialog: false
    }
  },
  async created () {
    try {
      await this.getAllList()
    } catch (e) {
      console.log(e)
    }
  },

  methods: {
    getSearchData (search) {
      Store.store('search', search)
      this.getAllList()
    },
    async saveMutiEdit () {
      const res = await mutiEdit(this, this.allValidityPeriod)
      if (Number.parseInt(res.ret) === 1) {
        this.$message.success('修改成功')
        this.getAllList()
        this.hideMutiEditDialog()
      } else {
        this.$message.error(res.msg)
      }
    },
    hideMutiEditDialog () {
      this.showMutiEditDialog = false
    },
    addHandler () {
      this.show_add_card = true
    },
    mutiEditHandler () {
      this.showMutiEditDialog = true
    },
    setCurrentChannel (item) {
      // ('---channel---', item)
      Store.store('current_channel', item.channel)
      Store.store('current_association', item)
    },
    getAllList () {
      allOnAssociation(this, this.search)
      allOffAssociation(this, this.search)
    }
  }
}
</script>
<style scoped>
.step-main {
  min-width: 340px;
  display: flex;
  flex-direction: column;
  margin-top: 12px;

}

.stop-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.stop-img {
  width: 20px;
  height: 20px;
}
.stop-title {
  font-family: 'PingFangSC-Regular', 'PingFang SC';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #6699FF;
}
.stop-left {
  margin-left: 20px;
  display: flex;
}
</style>
